import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import React from 'react';
import ViewApplication from '../../modules/withdrawal/ViewApplication';

interface ViewApplicationPageProps {
  isTransactionHistory?: boolean;
}

const ViewApplicationPage = ({ isTransactionHistory = false }: ViewApplicationPageProps) => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('withdrawal->>ViewApplication.TitleHeader')} />
      <ViewApplication isTransactionHistory={isTransactionHistory} />
    </>
  );
};

export default ViewApplicationPage;
